import { all, put, call, fork, take } from "redux-saga/effects";
import * as api from "../../utils/api";
import {
  GET_PROFILE_REQUEST,
  GET_PROFILEHASH_REQUEST,
  GET_PROFILE_INFO_REQUEST,
  UPDATE_PROFILE_REQUEST,
  GET_NOTIFICATIONS_REQUEST,
  GET_UNSEEN_NOTIFICATIONS_REQUEST,
  SET_UNREAD_STATUS_REQUEST,
  SET_SEEN_STATUS_BULK_REQUEST,
  GET_TASKS_REQUEST,
  ADD_WHEEL_POINTS,
  userActions,
} from "./actions";

import { clientActions } from "./../client/actions";

export function* asyncGetProfile({ payload, resolve, reject }) {
  try {
    const response = yield call(api.getProfile, payload);
    if (response.status === 200 && response.data) {
      yield put(userActions.getProfileSuccess(response.data));
    }
    resolve(response.data);
  } catch (err) {
    reject && reject(err);
  }
}

export function* watchGetProfile() {
  while (true) {
    const action = yield take(GET_PROFILE_REQUEST);
    yield* asyncGetProfile(action);
  }
}

export function* asyncGetProfileFromHash({ payload, resolve, reject }) {
  try {
    const response = yield call(api.getProfileFromHash, payload);
    if (response.status === 200 && response.data) {
      yield put(userActions.getProfileFromHashSuccess(response.data));
      yield put(clientActions.setClientFromUserHash(response.data.client));
    }
    resolve(response.data);
  } catch (err) {
    reject(err);
  }
}

export function* watchGetProfileFromHash() {
  while (true) {
    const action = yield take(GET_PROFILEHASH_REQUEST);
    yield* asyncGetProfileFromHash(action);
  }
}

export function* asyncUpdateProfile({ payload, resolve, reject }) {
  try {
    const response = yield call(api.updateProfile, payload);
    if (response.status === 200 && response.data) {
      yield put(userActions.updateProfileSuccess(response.data));
    }
    resolve(response.data);
  } catch (err) {
    reject(err);
  }
}

export function* watchUpdateProfile() {
  while (true) {
    const action = yield take(UPDATE_PROFILE_REQUEST);
    yield* asyncUpdateProfile(action);
  }
}

export function* watchGetProfileInfo() {
  while (true) {
    const action = yield take(GET_PROFILE_INFO_REQUEST);
    yield* asyncGetProfileInfo(action);
  }
}

export function* asyncGetProfileInfo({ payload, resolve, reject }) {
  try {
    const response = yield call(api.getProfileInfo, payload);
    if (response.status === 200 && response.data) {
      yield put(userActions.getProfileInfoSuccess(response.data));
    }
    resolve(response.data);
  } catch (err) {
    reject(err);
  }
}

export function* asyncGetNotifications({ resolve, reject }) {
  try {
    const response = yield call(api.getNotifications);
    if (response.status === 200 && response.data) {
      yield put(userActions.getNotificationsSuccess(response.data));
    }
    resolve(response.data);
  } catch (err) {
    reject(err);
  }
}

export function* watchGetNotifications() {
  while (true) {
    const action = yield take(GET_NOTIFICATIONS_REQUEST);
    yield* asyncGetNotifications(action);
  }
}

export function* asyncGetUnseenNotificationsCount({ resolve, reject }) {
  try {
    const response = yield call(api.getUnseenNotificationsCount);
    if (response.status === 200 && response.data) {
      yield put(userActions.getUnseenNotificationsCountSuccess(response.data));
    }
    resolve(response.data);
  } catch (err) {
    reject(err);
  }
}

export function* watchGetUnseenNotificationsCount() {
  while (true) {
    const action = yield take(GET_UNSEEN_NOTIFICATIONS_REQUEST);
    yield* asyncGetUnseenNotificationsCount(action);
  }
}

export function* asyncSetUnreadStatus({ payload, resolve, reject }) {
  try {
    const response = yield call(api.setUnreadStatus, payload);
    if (response.status === 200 && response.data) {
      yield put(userActions.setUnreadStatusSuccess(payload));
    }
    resolve(payload);
  } catch (err) {
    reject(err);
  }
}

export function* watchSetUnreadStatus() {
  while (true) {
    const action = yield take(SET_UNREAD_STATUS_REQUEST);
    yield* asyncSetUnreadStatus(action);
  }
}

export function* asyncSetSeenStatusBulk({ payload, resolve, reject }) {
  try {
    const response = yield call(api.setSeenStatusBulk, payload);
    if (response.status === 200 && response.data) {
      yield put(userActions.setSeenStatusBulkSuccess(payload));
    }
    resolve(response.data);
  } catch (err) {
    reject(err);
  }
}

export function* watchSetSeenStatusBulk() {
  while (true) {
    const action = yield take(SET_SEEN_STATUS_BULK_REQUEST);
    yield* asyncSetSeenStatusBulk(action);
  }
}

export function* asyncGetTasks({ resolve, reject }) {
  try {
    const response = yield call(api.getUsersTasks);
    if (response.status === 200 && response.data) {
      yield put(userActions.getTasksSuccess(response.data));
    }
    resolve(response.data);
  } catch (err) {
    reject(err);
  }
}

export function* watchGetTasks() {
  while (true) {
    const action = yield take(GET_TASKS_REQUEST);
    yield* asyncGetTasks(action);
  }
}

export function* addWheelPoints({ payload, resolve, reject }) {
  try {
    const response = yield call(api.addWheelPoints, payload);
    if (response.status === 200 && response.data) {
      yield put(userActions.addWheelPointsSuccess({ ...response.data, earnedPoints: payload.earnedPoints }));
    }
    resolve(response.data);
  } catch (err) {
    reject(err);
  }
}

export function* watchAddWheelPoints() {
  while (true) {
    const action = yield take(ADD_WHEEL_POINTS);
    yield* addWheelPoints(action);
  }
}

export default function* () {
  yield all([
    fork(watchGetProfile),
    fork(watchGetProfileFromHash),
    fork(watchUpdateProfile),
    fork(watchGetProfileInfo),
    fork(watchGetNotifications),
    fork(watchGetUnseenNotificationsCount),
    fork(watchSetUnreadStatus),
    fork(watchSetSeenStatusBulk),
    fork(watchGetTasks),
    fork(watchAddWheelPoints),
  ]);
}
